<template>
	<div>
		<div
			class="modal fade"
			id="exportFilePopUp"
			tabindex="-1"
			role="dialog"
			aria-labelledby="openModal"
			aria-hidden="true"
			data-backdrop="static"
		>
			<div class="modal-dialog modal-lg" role="document">
				<div
					class="modal-content campaign-g-addedit"
					style="width:1000px;height:260px;margin-left:-49px;top:80px"
				>
					<div class="modal-header" style = "flex: 0 0 auto">
						<h5 class="modal-title" id="exampleModalLongTitle">Export Products</h5>
						<button type="button" class="close" data-dismiss="modal" @click = "getList">
							<span aria-hidden="true">&times;</span>
						</button>
					</div>
					<div class="modal-body" style="margin-top:25px;margin-left:40px;">
						<div class = "form-group row">
							<span v-if = "errorMessage">{{ errorMessage }}</span>
							<div v-else-if = "isTimeOut">
								<p>We are processing your request, this may take some time...Please wait</p>
							</div>
							<div v-else-if = "downloadLink">
								<span><a :href = "downloadLink" target="_blank" download>Click here</a> to download the products</span>
							</div>
							<div v-else>
								<span>A product export file has been sent to your email address.</span>
							</div>
						</div>
					</div>

					<div class="modal-footer" style = "flex: 0 0 auto">
						<div class="mt-2" style="text-align: center">
							<button type="button" class="btn btn-primary" data-dismiss="modal" @click = "getList">Done</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import XLSX from "xlsx";

	export default {
		name: "ExportFilePopUp",
		components: {
		},
		props:["isTimeOut", "downloadLink", "errorMessage"],
		mounted() {
			//this.openCampaignGroup();
		},
		data() {
			return {

			};
		},
		watch: {},
		methods: {
			getList(){
				this.$emit("closePopUpExport")
			},
			openNewTab(data){
				let safariAgent = navigator.userAgent.indexOf("Safari") > -1;
				let chromeAgent = navigator.userAgent.indexOf("Chrome") > -1;
				if(safariAgent && !chromeAgent){
						var link = document.createElement('a');
						link.href = data;
						link.download = "product-file.csv";
						link.target = "_blank";
						link.click();
				}
				else{
					let newWindow =  window.open(data, "_blank")
				}
			}
		}
}
</script>
<style lang="scss">
</style>
